@let disabled = disabled$ | async;
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="control | controlHasRequired"
  [validating]="validating$()"
  [disabled]="disabled || validating$()"
  [touched]="isTouched$ | async"
  [dirty]="isDirty$ | async"
  [alignment]="alignment"
  [config]="config">
  <input
    #inputRef
    type="text"
    class="form-control app-datepicker"
    bsDatepicker
    #bsDatepickerRef="bsDatepicker"
    [ngClass]="{ 'app-datepicker__disabled': disabled || validating$() }"
    [outsideClick]="true"
    [placeholder]="officeField?.InputMask || ''"
    [name]="officeField.VistaFormItem.ColumnName"
    [bsConfig]="datePickerOptions"
    [formControl]="innerControl"
    [isDisabled]="disabled || validating$() ? '' : null" />
  <div class="input-group-append">
    <button
      type="button"
      class="btn btn-outline-secondary app-datepicker__btn"
      [disabled]="disabled || validating$()"
      (click)="bsDatepickerRef.toggle()"
      [attr.aria-expanded]="bsDatepickerRef.isOpen">
      <i class="oi oi-calendar"></i>
    </button>
  </div>
</app-control-wrapper>
